import React, { useRef, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import Model from './Model';
import { registerEventGeometry } from '../events';
import useProps from "../_util/useProps";

export default function(props) {
    const {data, property, label, flyTo, model, ...v} = props;
    const featureRef = useRef();
    const { featureLayer, map } = useProps();

    useEffect(() => {
        let feature = new Model({
            geometry: data,
            properties: property,
            label,
            model,
            ...v
        });

        // 注册事件
        registerEventGeometry(feature, props);


        if (featureLayer) {
            featureLayer.entities.add(feature);
        } else {
            map.entities.add(feature);
        }


        if (flyTo) {
            map.flyTo(feature);
        }

        featureRef.current = feature;

        return () => {
            if (featureLayer) {
                featureLayer.entities.remove(feature);
            } else {
                map.entities.remove(feature);
            }
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setUrl(model.url);
    }, [model?.url]);

    useUpdateEffect(() => {
        featureRef.current.setScale(model.scale);
    }, [model?.scale]);

    useUpdateEffect(() => {
        featureRef.current.setRotate(model.rotate);
    }, [model?.rotate]);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [JSON.stringify(property)]);

    useUpdateEffect(() => {
        featureRef.current.setLabel(label);
    }, [JSON.stringify(label)]);

    return <></>;
}
